import { all, put, take, race, select, takeEvery } from 'redux-saga/effects'
import { SUCCESS, FAILED } from 'crom-api-constants'
import _ from 'lodash'

import { getToken, getLocale } from '@global/selectors'

import { blockSaveCustomData } from '../../../../../../../../../../../components/Workspace/components/HocBlock/actions'
import config from '../../../../../../../../../../../../../config'

import {
    LIENS_SHARE_TABLE_CHANGE,
    LIENS_SHARE_TABLE_LOADING_TRUE,
    LIENS_SHARE_TABLE_LOADING_FALSE,
    LIENS_SHARE_TABLE_CHANGE_REQUEST,
    LIENS_SHARE_TABLE_DATA_RECEIVED,
} from './constants'

import {
    shareTableLoadingTrue,
    shareTableChangeRequest,
    shareTableDataReceived,
    shareTableLoadingFalse,
} from './actions'

const LIENS_SHARE_TABLE_CHANGE_REQUEST_SUCCESS = (id) => `${LIENS_SHARE_TABLE_CHANGE_REQUEST(id)}_${SUCCESS}`
const LIENS_SHARE_TABLE_CHANGE_REQUEST_FAILED = (id) => `${LIENS_SHARE_TABLE_CHANGE_REQUEST(id)}_${FAILED}`

function* liensShareTableCallSaga(action) {
    const block = _.get(action, 'data.block', null)
    if (block !== config.modules.report.blocks.liens.key) return null

    const module = _.get(action, 'data.module', null)
    const id = _.get(action, 'data.id', null)
    if (!module || !block || !id) return null

    const level = _.get(action, 'data.level', null)
    const customData = _.get(action, 'data.customData', null)
    const qs = _.get(action, 'data.qs', null)
    const locale = yield select(getLocale)
    const token = yield select(getToken, id, module)
    const lang = config.languages[locale].requestKey

    yield put(
        shareTableLoadingTrue(module, block, id, {
            ...customData,
            share: {
                ...customData.share,
                table: {
                    ...customData.share.table,
                    isLoading: true,
                },
            },
        })
    )

    const filters = _.reduce(
        _.get(qs, 'filtered'),
        (acc, filter) => ({
            ...acc,
            [`${filter.id}[]`]: filter.value,
        }),
        {}
    )

    const qp = {
        page: _.get(qs, 'pagination.page'),
        rows: _.get(qs, 'pagination.rowsPerPage'),
        'sort[]': _.map(_.get(qs, 'sorted', []), (val) => `${_.get(val, 'id')}${val.desc ? ':desc' : ':asc'}`),
        ...filters,
    }

    yield put(shareTableChangeRequest(module, block, id, level, lang, token, qp))

    const response = yield race({
        success: take(LIENS_SHARE_TABLE_CHANGE_REQUEST_SUCCESS(id)),
        failed: take(LIENS_SHARE_TABLE_CHANGE_REQUEST_FAILED(id)),
    })

    if (!response.failed) {
        const data = _.map(_.get(response, 'success.payload.response.body.rows'), (row) => ({ ...row }))
        const query = _.get(response, 'success.payload.response.body.query', [])
        const pagination = _.get(query, 'pagination', null)
        const filter = _.get(query, 'filter', null)
        const sorted = _.reduce(
            _.get(query, 'sort.sortedColumns'),
            (acc, val) => [
                ...acc,
                {
                    id: _.get(val, 'columm'), // TYPO FROM BACKEND
                    desc: _.get(val, 'direction') === 'desc',
                },
            ],
            []
        )

        const newCustomData = {
            ...customData,
            share: {
                ...customData.share,
                table: {
                    data,
                    pagination,
                    sorted,
                    filter,
                    isLoading: false,
                },
            },
        }

        yield put(shareTableDataReceived(module, block, id, newCustomData))
    } else {
        yield put(
            shareTableLoadingFalse(module, block, id, {
                ...customData,
                share: {
                    ...customData.share,
                    table: {
                        ...customData.share.table,
                        isLoading: false,
                    },
                },
            })
        )
    }

    return null
}

function* liensChangeCustomData(action) {
    const blockKey = _.get(action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.liens.key) return null

    const module = _.get(action, 'data.module', null)
    const id = _.get(action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const customData = _.get(action, 'data.customData', null)

    yield put(blockSaveCustomData(module, id, blockKey, customData))

    return null
}

export default function* liensShareTableSaga() {
    yield all([
        takeEvery(LIENS_SHARE_TABLE_CHANGE, liensShareTableCallSaga),
        takeEvery(LIENS_SHARE_TABLE_LOADING_TRUE, liensChangeCustomData),
        takeEvery(LIENS_SHARE_TABLE_LOADING_FALSE, liensChangeCustomData),
        takeEvery(LIENS_SHARE_TABLE_DATA_RECEIVED, liensChangeCustomData),
    ])
}
